import type { TGetVendedoresUnidadeNegocioResponse } from '@/features/proposta/interfaces/proposta.type'
import { HttpService } from '@/infra/http'

export class GetVendedoresUnidadeNegocio extends HttpService {
  execute = async () => {
    return this.http.get<TGetVendedoresUnidadeNegocioResponse>(`/api/v2/Colaborador/vendedores`)
  }
}
